import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Sponsor } from "../models";
import { Injectable } from '@angular/core';
import { GuestRole } from '../models/guest-role.model';

@Injectable()
export class SponsorService{
    private url = "/api/sponsors";

    constructor (private http : HttpClient) {}

    getSponsors() : Observable<Sponsor[]> {
        return this.http.get<Sponsor[]>(`${this.url}`);
    }

    getGuestRolesBySponsorId(id : number) : Observable<GuestRole[]> {
        return this.http.get<GuestRole[]>(`${this.url}/${id}/guests`);
    }

    getSponsorById(id: number) : Observable<Sponsor> {
        return this.http.get<Sponsor>(`${this.url}/${id}`);
    }
}